<template>
  <div class="header-wrap">
    <div class="header bg-center">
      <h1>{{ regionName }}溯源大数据</h1>
    </div>
  </div>
</template>

<script>

import {mapState} from "vuex"; 	
export default {
  data() {
    return {
    };
  },
  computed:{
	...mapState(['regionName'])  
  },
  mounted() {
  }
};
</script>

<style lang='less'>
.header-wrap {
    width: 100%;
    height: 100px;
    position: relative;
    min-width: 1200px;
    z-index: 999;
    background-image: url("../assets/images/title-bg.png");
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: 0px 65px;
}
.header {
  height: 100px;
/*  width: 576px; */
/*  background-image: url("../assets/images/title-bg.png"); */
  margin: 0 auto;
  text-align: center;
  line-height: 80px;
  h1 {
    font-size: 3rem;
    font-family: "黑体";
    color: #4FCCFF;
    font-weight: 900;
  }
}
</style>